function CodeNotFound() {

    return (
        <div className="container">
          <div style={{backgroundColor:'#0c97ec', color:'#fff', textAlign:'center', padding:50}}>
              <h2>Invalid Offer Code</h2>
              <div>Looks your offer code is expired or nnvalid.</div>
          </div>
        </div>
    );
  }
  
  export default CodeNotFound;